import { Page } from '@/domains';
import { PurchasedCredits } from '@/domains/purchased-credits';

import { authorizedApi } from '@/services/network/authorized-api';

export const getPurchasedCredits = (pageNumber: number, pageSize: number, options?: { [x: string]: any }) =>
  authorizedApi.get<Page<PurchasedCredits>>(`/credits`, { pageNumber, pageSize, ...options });
